var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 82,
    viewBox: "0 0 60 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 82,
    rx: 5.85714,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.98277 25V12.416L7.01277 14.242V10.942L9.98277 9.16H13.0408V25H9.98277ZM20.897 25.33C19.7237 25.33 18.697 25.0843 17.817 24.593C16.937 24.1017 16.2513 23.416 15.76 22.536C15.2687 21.656 15.023 20.6293 15.023 19.456V14.704C15.023 13.5307 15.2687 12.504 15.76 11.624C16.2513 10.744 16.937 10.0583 17.817 9.567C18.697 9.07567 19.7237 8.83 20.897 8.83C22.0703 8.83 23.097 9.07567 23.977 9.567C24.857 10.0583 25.5427 10.744 26.034 11.624C26.5253 12.504 26.771 13.5307 26.771 14.704V19.456C26.771 20.6293 26.5253 21.656 26.034 22.536C25.5427 23.416 24.857 24.1017 23.977 24.593C23.097 25.0843 22.0703 25.33 20.897 25.33ZM20.897 22.492C21.425 22.492 21.9017 22.3673 22.327 22.118C22.7523 21.8687 23.0897 21.5313 23.339 21.106C23.5883 20.6807 23.713 20.204 23.713 19.676V14.462C23.713 13.934 23.5883 13.4573 23.339 13.032C23.0897 12.6067 22.7523 12.2693 22.327 12.02C21.9017 11.7707 21.425 11.646 20.897 11.646C20.369 11.646 19.8923 11.7707 19.467 12.02C19.0417 12.2693 18.7043 12.6067 18.455 13.032C18.2057 13.4573 18.081 13.934 18.081 14.462V19.676C18.081 20.204 18.2057 20.6807 18.455 21.106C18.7043 21.5313 19.0417 21.8687 19.467 22.118C19.8923 22.3673 20.369 22.492 20.897 22.492Z",
    fill: "#2B65CF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.75 39C24.1525 39 17 46.1525 17 47.75C17 46.1525 9.84751 39 8.25 39C9.84751 39 17 31.8475 17 30.25C17 31.8475 24.1525 39 25.75 39Z",
    fill: "#2B65CF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.75 59C49.8745 59 37 71.8745 37 74.75C37 71.8745 24.1255 59 21.25 59C24.1255 59 37 46.1255 37 43.25C37 46.1255 49.8745 59 52.75 59Z",
    fill: "#2B65CF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTd);
export default __webpack_public_path__ + "static/media/td.f16b7af23dedb0569041d6b079c98b96.svg";
export { ForwardRef as ReactComponent };